import { ChatParticipant, OrganizationMember } from '@prisma/client'
import React from 'react'
import { styled } from 'styled-components'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { OrganizationType } from '~/features/organization/common'

const PlaceholderWrapper = styled.div<{ color: string }>`
  position: relative;
  height: 10em;
  overflow: hidden;
`

const getTranslucentColor = (color: string, alpha = 0.1): string => {
  if (color.startsWith('rgba')) {
    return color.replace(/rgba?\(([^)]+)\)/, (_, values) => {
      const [r, g, b] = values.split(',').map(v => parseFloat(v.trim()))
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    })
  }

  if (color.startsWith('#')) {
    const hex = color.replace('#', '')
    const bigint = parseInt(
      hex.length === 3
        ? hex
            .split('')
            .map(c => c + c)
            .join('')
        : hex,
      16,
    )
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  return getTranslucentColor('rgba(151, 151, 151)')
}

type Props = {
  organization: OrganizationType
  organizationMember: OrganizationMember
  organizationMembers: OrganizationMemberFromContext[]
  participants: ChatParticipant[]
}

export const ThreadPlaceholder: React.FC<Props> = ({ organization }) => {
  return <PlaceholderWrapper color={'none'} />
}
